import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>Collary</h3>
          <p>Votre partenaire de confiance pour la gestion des plannings médicaux.</p>
        </div>
        
        <div class="footer-section">
          <h3>Liens utiles</h3>
          <ul>
            <li><a routerLink="/">Accueil</a></li>
            <li><a routerLink="/privacy-policy">Politique de confidentialité</a></li>
            <li><a href="#" (click)="showCookieInfo($event)">Utilisation des cookies</a></li>
          </ul>
        </div>
        
        <div class="footer-section">
          <h3>Contact</h3>
          <p>Email: contact&#64;collary.com</p>
          <p>Tél: +33 1 23 45 67 89</p>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; {{currentYear}} Collary. Tous droits réservés.</p>
      </div>
    </footer>

    <!-- Popup d'information sur les cookies -->
    <div *ngIf="showCookiePopup" class="cookie-popup">
      <div class="cookie-content">
        <h3>Utilisation des cookies</h3>
        <p>Nous utilisons des cookies pour améliorer votre expérience sur notre site :</p>
        <ul>
          <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site</li>
          <li><strong>Cookies de préférences :</strong> Pour mémoriser vos paramètres</li>
          <li><strong>Cookies analytiques :</strong> Pour améliorer nos services</li>
          <li><strong>Cookies marketing :</strong> Pour personnaliser votre expérience</li>
        </ul>
        <p>Vous pouvez gérer vos préférences de cookies à tout moment via notre bannière de consentement.</p>
        <button (click)="closeCookiePopup()" class="btn-close-rgpd">Fermer</button>
      </div>
    </div>
  `,
  styles: [`
    .footer {
      background-color: #f8f9fa;
      padding: 2rem 0;
      margin-top: 3rem;
    }

    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
      padding: 0 1rem;
    }

    .footer-section h3 {
      color: #333;
      margin-bottom: 1rem;
    }

    .footer-section ul {
      list-style: none;
      padding: 0;
    }

    .footer-section ul li {
      margin-bottom: 0.5rem;
    }

    .footer-section a {
      color: #666;
      text-decoration: none;
      transition: color 0.3s;
    }

    .footer-section a:hover {
      color: #007bff;
    }

    .footer-bottom {
      text-align: center;
      margin-top: 2rem;
      padding-top: 1rem;
      border-top: 1px solid #dee2e6;
    }

    .cookie-popup {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }

    .cookie-content {
      background: white;
      padding: 2rem;
      border-radius: 8px;
      max-width: 600px;
      width: 90%;
      max-height: 90vh;
      overflow-y: auto;
    }

    .cookie-content h3 {
      color: #333;
      margin-bottom: 1rem;
    }

    .cookie-content ul {
      list-style: disc;
      margin-left: 1.5rem;
      margin-bottom: 1rem;
    }

    .cookie-content li {
      margin-bottom: 0.5rem;
    }

    .btn-close-rgpd {
      background: #0e425b;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 8px;
      cursor: pointer;
      margin-top: 1rem;
      font-size: 1rem;
    }

    .btn-close-rgpd:hover {
      background: #0a3040;
    }
  `]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  showCookiePopup = false;

  showCookieInfo(event: Event) {
    event.preventDefault();
    this.showCookiePopup = true;
  }

  closeCookiePopup() {
    this.showCookiePopup = false;
  }
} 